/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const WebhookClusterGwPostgresUpgradePost = {
  id: 'webhook.cluster-gw.postgres-upgrade.post',
  tag: 'Webhook',
  summary: 'Handle ClusterGW Postgres Upgrade',
  description: 'Handle ClusterGW Postgres Upgrade',
  method: 'post',
  route: () => `/webhook/clustergw/upgrade`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            uid: z.string(),
            event: z.literal('Normal'),
            action: z.literal('major_version_upgrade'),
            payload: z.object({
              workspace_id: z.string(),
              customer_id: z.number().int(),
              cluster_id: z.number().int(),
              message: z.string(),
            }),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
